import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";
toast.configure();


export const getTotalQueueCount = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/dashboardNew`, params, token, dispatch).then(
            (response) => {
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};

export const getDocUploadCountToday = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/dashboardNew/docUploadToday`, params, token, dispatch).then(
            (response) => {
                console.log('sddaasdasd', response)
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};

export const getBarChartData = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/dashboardNew/barChartData`, params, token, dispatch).then(
            (response) => {
                console.log('dasdsafafdaf', response)
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.warn(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};
